import { supabase } from "../lib/supabase";
import { BossSkillEffectRelation } from "../types";

export type RelationKey = Pick<
  BossSkillEffectRelation,
  "skill" | "effect" | "order"
>;
export type RelationValues = Pick<
  BossSkillEffectRelation,
  | "skill"
  | "effect"
  | "order"
  | "power"
  | "duration_s"
  | "add_count"
  | "property_category"
  | "property_element"
  | "priority"
>;
const fields = [
  "skill",
  "effect",
  "order",
  "power",
  "duration_s",
  "add_count",
  "property_category",
  "property_element",
  "priority",
];
function writable(values: Partial<RelationValues>) {
  return Object.fromEntries(
    Object.entries(values).filter(
      ([key, value]) => fields.includes(key) && value !== undefined,
    ),
  );
}
function match(query: any, key: RelationKey) {
  if (!key?.skill || !key.effect || !Number.isInteger(key.order))
    throw new Error(
      "효과 연결의 원본 키를 확인할 수 없습니다. 새로고침 후 다시 시도하세요.",
    );
  return query
    .eq("skill", key.skill)
    .eq("effect", key.effect)
    .eq("order", key.order);
}
export const skillEffectRelationApi = {
  async getAll(): Promise<BossSkillEffectRelation[]> {
    const { data, error } = await supabase
      .from("boss_skill_effect_relation_renewed")
      .select("*")
      .order("skill")
      .order("order");
    if (error) throw error;
    return data || [];
  },
  async getBySkill(skill: string): Promise<BossSkillEffectRelation[]> {
    const { data, error } = await supabase
      .from("boss_skill_effect_relation_renewed")
      .select("*")
      .eq("skill", skill)
      .order("order");
    if (error) throw error;
    return data || [];
  },
  async getByEffect(effect: string): Promise<BossSkillEffectRelation[]> {
    const { data, error } = await supabase
      .from("boss_skill_effect_relation_renewed")
      .select("*")
      .eq("effect", effect)
      .order("order");
    if (error) throw error;
    return data || [];
  },
  async create(
    values: Partial<RelationValues>,
  ): Promise<BossSkillEffectRelation> {
    const { data, error } = await supabase
      .from("boss_skill_effect_relation_renewed")
      .insert(writable(values))
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  async update(
    original: RelationKey,
    values: Partial<RelationValues>,
  ): Promise<BossSkillEffectRelation> {
    const { data, error } = await match(
      supabase
        .from("boss_skill_effect_relation_renewed")
        .update(writable(values)),
      original,
    )
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  async delete(original: RelationKey): Promise<void> {
    const { error } = await match(
      supabase.from("boss_skill_effect_relation_renewed").delete(),
      original,
    )
      .select()
      .single();
    if (error) throw error;
  },
  async deleteBySkill(skill: string): Promise<void> {
    if (!skill) throw new Error("스킬 키가 필요합니다.");
    const { error } = await supabase
      .from("boss_skill_effect_relation_renewed")
      .delete()
      .eq("skill", skill);
    if (error) throw error;
  },
};
